<script>
  import { asteroid } from "@/meteor.js";
  import { fade } from "svelte/transition";
  import { flip } from "svelte/animate";

  export let receive, send, user, scoped;
  let password = "";

console.log('scoped', scoped)

  let role = ""; //new users have no role prop
  $: userId = user && user._id;
  let roles = [
    { name: "Admin", value: "admin" },
    { name: "Redaktør", value: "editor" },
    { name: "Insider", value: "reader" },
    { name: "Ingen adgang", value: "" }
  ];

  $: fetchRole(user);

  function fetchRole(user) {
    role = (user && user.role) || "";
  }

  function update() {
    asteroid.call("user.update", userId, { role, password });
    history.pushState({}, "", "/users");
  }
</script>

{#if user}
  <div class="fixed inset-0 flex flex-wrap justify-center content-center">
    <div
      class="backdrop"
      on:click={() => history.pushState({}, '', '/users')}
      in:fade
      out:fade={{ duration: 150 }} />
    {#if user}
      <div
        class="bg-white w-1/2 relative shadow-xl px-16 py-8 text-center
        rounded-lg text-xl"
        in:receive={{ key: 'userBox' }}
        out:send={{ key: 'userBox' }}>

        <div>
          <h3 class="text-2xl">{user.emails[0].address}</h3>
        </div>
        <div class="py-8">
          <label for="password" class="pr-4">Adgangskode</label>
          <input
            type="password"
            id="password"
            bind:value={password}
            class="shadow-inner text-xl bg-gray-100" />
        </div>
        <div class="pb-10">
          Rolle:
          <select bind:value={role}>
            {#each roles as role}
              <option value={role.value}>{role.name}</option>
            {/each}
          </select>
        </div>

        <div class="h-12">
          <button on:click={update} class="btn solid green">Opdater</button>
        </div>
        <a
          class="absolute top-0 right-0 mr-6 mt-2"
          href={'/logs/user/' + user._id}>
          Log
        </a>
      </div>
    {/if}
  </div>
{/if}
